import { usePlayroomRewardsTranslations } from "../../../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ExchangeError = function ExchangeError(_ref) {
  var messageError = _ref.messageError,
    onClose = _ref.onClose;
  var _usePlayroomRewardsTr = usePlayroomRewardsTranslations(),
    t = _usePlayroomRewardsTr.t;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-text-center",
    children: [/*#__PURE__*/_jsx("h2", {
      className: "tw-font-subtitle2 tw-mb-1.6",
      children: t('PRS_EXCHANGE_FAILED_TITLE')
    }), /*#__PURE__*/_jsx("p", {
      className: "tw-font-body4 tw-mb-3.2",
      children: t('PRS_EXCHANGE_FAILED_DESCRIPTION')
    }), !!messageError && /*#__PURE__*/_jsx("code", {
      className: "tw-block tw-mb-1.2 tw-w-full tw-h-14.4 tw-overflow-x-hidden tw-overflow-y-auto",
      children: messageError
    }), /*#__PURE__*/_jsx("button", {
      type: "button",
      className: "tw-btn-primary-s",
      onClick: onClose,
      children: t('PRS_EXCHANGE_FAILED_OK')
    })]
  });
};
export default ExchangeError;